import dayjs from "dayjs";
import { ObjectGeneric } from "../../../../../utils/types/generals"
import { Constants } from "../../../../../utils/constants";
import { FrequencyEnum, ScheduleEnumType } from "../../../../calendar/pages/form/components/steps/configCalendar/enums";
import { getDataByFrequency, getDayText, getFrecuencyNameText } from "../../../../calendar/pages/main/methods";

export const formatDataToEndoint = ({ data, selected, selectedDays, option }: { data: ObjectGeneric, selectedDays?: number[], selected: { users: number[]; questionnaire: number[]; }, option: ScheduleEnumType }) => {
    let body: {
        dateStart?: string
        dateEnd?: string
        questionnaireMainId: number
        userAssignId: number
        notified?: number
        notifyAdmin: number
        openScheduled: boolean
        storeId?: string | null
        timeStart?: string | null
        timeEnd?: string | null
        duration?: number | null
        days?: number[] | null
        frequency?: string
        every?: string | null
    }[] = []

    if (option !== ScheduleEnumType.RECURRENT) {
        const { dateEnd, dateStart, duration, every, frequency, timeEnd, timeStart } = getDataByFrequency(data);

        body.push({
            openScheduled: !!data.openQuestionnaire,
            questionnaireMainId: selected.questionnaire[0],
            storeId: !data.store ? null : data.store?.value ? data.store?.value : data.store,
            userAssignId: selected.users[0],
            notified: data.notified ? 1 : 0,
            notifyAdmin: data.notifiedAdmin ? 1 : 0,
            ...!data.openQuestionnaire && {
                dateStart: dateStart,
                dateEnd: dateEnd,
                every: every,
                timeStart: timeStart,
                timeEnd: timeEnd,
                frequency: frequency,
                duration: duration,
                days: selectedDays?.map((num: number) => num === 7 ? 0 : num)
            }
        })
    }

    if (option == ScheduleEnumType.RECURRENT) {
        const frequencyText = getFrecuencyNameText(data.frequency as FrequencyEnum);

        body.push({
            openScheduled: !!data.openQuestionnaire,
            questionnaireMainId: selected.questionnaire[0],
            storeId: !data.store ? null : data.store?.value ? data.store?.value : data.store,
            userAssignId: selected.users[0],
            notified: data.notified ? 1 : 0,
            notifyAdmin: data.notifiedAdmin ? 1 : 0,
            ...!data.openQuestionnaire && {
                dateStart: dayjs(data.from).format(Constants.dayjsFormat3),
                dateEnd: dayjs(data.to).format(Constants.dayjsFormat3),
                every: getDayText(data.dayOfWeek),
                timeStart: data.from?.format(Constants.timeFormat),
                timeEnd: data.to?.format(Constants.timeFormat),
                frequency: frequencyText,
                duration: Number(data.duration.match(/\d+/)?.[0]),
                days: selectedDays?.map((num: number) => num === 7 ? 0 : num)
            }
        })
    }


    return body
}